

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ImageUploadIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#522cdf' }) readonly color?: string;
  @Prop({ default: '#d3dafc' }) readonly colorCircle?: string;
}
